// API endpoint pro odesílání emailů přes Vercel Serverless Function
// Vercel automaticky zpřístupní /api/send/application jako serverless function
const API_URL = '';

export const sendRegistrationEmail = async (data) => {
  try {
    const response = await fetch(`${API_URL}/api/send/application`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ error: 'Neznámá chyba' }));
      throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Chyba při odesílání emailu:', error);
    throw error;
  }
};